import React, { Component } from "react";
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hasError: false,
    };
  }

  componentDidCatch(error, info) {
    this.setState({
      hasError: true,
    },()=>{
      alert("Something went wrong, please go home.");
      console.group();
      console.log("Please Check the error info");
      console.error(info);
      console.groupEnd();
    });
  }
  render() {
    const { state } = this;
    var { hasError } = state;

    if (hasError) {
      return ( <div> <h1>Something went wrong.</h1> </div> );
    }
    
    return (
      <div>
        {this.props.children}
      </div>
    );
  }
}
